export default "__VITE_ASSET__DRP645fd__"